module.exports = __webpack_public_path__ + "img/icon_05.9dd4d851.png";